import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'is-date-navigator',
  templateUrl: './is-date-navigator.component.html',
  styleUrls: ['./is-date-navigator.component.scss']
})
export class IsDateNavigatorComponent implements OnInit {

  @Input() dateControl: UntypedFormControl = new UntypedFormControl(new Date());
  @Input() formatDate: UntypedFormControl = new UntypedFormControl(new Date());
  @Input() min;
  @Input() max;
  @Output() SelectedFrequencyValue = new EventEmitter();
  @Input() page: string;
  @Input() left: number;
  // the variable to show the div containing the select to change the formatting
  @Input() showSelectFormat: boolean = false;
  @Input() showFrequencies: boolean = true;
  // assign by default the format for day.
  // 'extended date' is a formats declared "it.json" it and "en.json"
  @Input() form: string = 'yearly';
  @Input() formatType = new UntypedFormControl(this.form);
  public listFrequency = [
    { name: 'Frequenza di acquisizione', id: 'none' },
    { name: 'Minuti', id: 'minutes' },
    { name: 'Ore', id: 'hours' },
    { name: 'Giornaliera', id: 'days' },
    { name: 'Settimanale', id: 'weeks' },
    { name: 'Mensile', id: 'months' },
    { name: 'Annuale', id: 'years' }
  ];
  // this list is used in the select.
  // the "select" key is the string shown in the options
  // the key "formattype" is the string used to format/translate the date
  public resultFrequency;
  public formatypeList: any[] = ['daily', 'weekly', 'monthly', 'yearly'];

  constructor(
    private _translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.resultFrequency = this.listFrequency[0];
  }

  /**
   * Change the current day
   * @param event number of days to add or subtract or new date.
   */
  public changeDate(event): void {
    if (typeof event === 'number') {
      if (this.formatType?.value === 'daily') {
        // if I have to add or subtract days i parse the
        // day using moment and reassign it as date
        this.dateControl.setValue(
          new Date(
            moment(this.dateControl?.value).add(event, 'day').toISOString()
          )
        );
      } else if (this.formatType?.value === 'monthly') {
        // if I have to add or subtract month i parse the
        // day using moment and reassign it as date
        this.dateControl.setValue(
          new Date(
            moment(this.dateControl?.value).add(event, 'month').toISOString()
          )
        );
      } else if (this.formatType?.value === 'weekly') {
        // if I have to add or subtract month i parse the
        // day using moment and reassign it as date
        this.dateControl.setValue(
          new Date(
            moment(this.dateControl?.value).add(event, 'week').toISOString()
          )
        );
      } else if (this.formatType?.value === 'yearly') {
        // if I have to add or subtract month i parse the
        // day using moment and reassign it as date
        this.dateControl.setValue(
          new Date(
            moment(this.dateControl?.value).add(event, 'year').toISOString()
          )
        );
      }
    } else if (typeof event?.value === 'object') {
      this.dateControl.setValue(new Date(event.value));
    }
  }

  public canChangeWith(param: number): boolean {
    const dateWhereMove = new Date(
      moment(this.dateControl?.value).add(param, 'days').toISOString()
    );
    const max = new Date(this.max);
    const min = new Date(this.min);
    if (this.max && max && dateWhereMove > max) {
      return false;
    }
    if (this.min && min && dateWhereMove < min) {
      return false;
    }
    return true;
  }

  public getDate(): string {
    let c: string;
    if (this.formatType.value === 'daily') {
      c = moment(this.dateControl.value).format(this._translateService.instant('FORMATS.extended_date'));
    } else if (this.formatType.value === 'monthly') {
      c = moment(this.dateControl.value).format(this._translateService.instant('FORMATS.extends_month'));
    } else if (this.formatType.value === 'weekly') {
      c = moment(this.dateControl.value).format(this._translateService.instant('FORMATS.extended_date'));
      c += ' - ' + moment(this.dateControl.value).add(1, 'week').format(this._translateService.instant('FORMATS.extended_date'));
    } else if (this.formatType.value === 'yearly') {
      c = moment(this.dateControl.value).format('YYYY');
    }
    return c;
  }

  public SelectedFrequency(event): void {
    this.SelectedFrequencyValue.emit(event);
  }
}
